import React, { useState, useEffect } from 'react';
import styles from './ElevatorWidget.module.css';

export default function ElevatorWidget() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 600);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={styles.lift} aria-hidden="true">
      {/* Kabin içi */}
      <div className={styles.cabin}>
        <div className={styles.cabinIcon}>⬆</div>
        <div className={styles.cabinName}>EMK ASANSÖR</div>
        <div className={styles.cabinSub}>KAT 1 — 12</div>
        <div className={styles.bars}>
          <div className={`${styles.bar} ${styles.barActive}`} />
          <div className={styles.bar} />
          <div className={styles.bar} />
          <div className={styles.bar} />
          <div className={styles.bar} />
        </div>
      </div>

      {/* Kapılar */}
      <div className={`${styles.door} ${styles.doorLeft}  ${open ? styles.doorOpen : ''}`}>
        <div className={styles.handle} />
      </div>
      <div className={`${styles.door} ${styles.doorRight} ${open ? styles.doorOpen : ''}`}>
        <div className={styles.handle} />
      </div>
    </div>
  );
}
